import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UserNotAdminOfOrganizationError = BaseErrorSchema.extend({
  errorType: z.literal('UserNotAdminOfOrganizationError'),
  userId: z.string(),
  organizationId: z.string(),
});

export type UserNotAdminOfOrganizationError = z.infer<
  typeof UserNotAdminOfOrganizationError
>;
